module.exports = __webpack_public_path__ + "img/g3.bd996b9b.jpg";